exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input {\n  width: 100%;\n  text-align: center;\n  background-image: none !important; }\n\nbutton, a {\n  margin: 0; }\n\n.spinner {\n  margin-top: 2px;\n  margin-bottom: 2px; }\n\n.odd {\n  padding-top: 3px;\n  padding-bottom: 3px;\n  background: #fafafa; }\n\n.even {\n  padding-top: 3px;\n  padding-bottom: 3px;\n  background: #eee; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/views/site-admin/company/users/users.component.scss
// module id = ../../../../../src/app/views/site-admin/company/users/users.component.scss
// module chunks = main